import React from 'react';
import { Plus } from 'lucide-react';
import './WarehousesHeader.css';

export default function WarehousesHeader({ onAdd }) {
  return (
    <div className="warehouses-header-container">
      <div className="warehouses-title-section">
        <h1 className="warehouses-title">Warehouses</h1>
        <p className="warehouses-subtitle">Manage storage facilities and inventory</p>
      </div>

      <div className="warehouses-actions-section">
        <button className="warehouses-add-button" onClick={onAdd}>
          <Plus size={18} className="warehouses-add-icon" />
          <span>Add Warehouse</span>
        </button>
      </div>
    </div>
  );
}
